import { Header } from "@/components/wedding/Header";
import { Hero } from "@/components/wedding/Hero";
import { OurStory } from "@/components/wedding/OurStory";
import { EventDetails } from "@/components/wedding/EventDetails";
import { Schedule } from "@/components/wedding/Schedule";
import { Gallery } from "@/components/wedding/Gallery";
import { Stay } from "@/components/wedding/Stay";
import { Parking } from "@/components/wedding/Parking";
import { Inspiration } from "@/components/wedding/Inspiration";
import { RsvpForm } from "@/components/wedding/RsvpForm";
import { GuestMap } from "@/components/wedding/GuestMap";
import { Registry } from "@/components/wedding/Registry";
import { Faq } from "@/components/wedding/Faq";
import { Contact, Footer } from "@/components/wedding/Contact";
import { RosePetalsIntro } from "@/components/wedding/RosePetalsIntro";
import { useLenis } from "@/hooks/useLenis";

export default function WeddingHome() {
  useLenis();
  return (
    <div className="bg-[color:var(--paper)] text-[color:var(--ink)] overflow-x-hidden">
      <RosePetalsIntro />
      <Header />
      <main>
        <Hero />
        <OurStory />
        <EventDetails />
        <Schedule />
        <Gallery />
        <RsvpForm />
        <GuestMap />
        <Registry />
        <Stay />
        <Parking />
        <Inspiration />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
